import React from "react";
import { useReducedMotion } from "../../hooks/useReducedMotion.ts";

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

/**
 * Reusable restrained dark-theme skeleton placeholder.
 * Decorative block hidden from screen readers via aria-hidden="true".
 * Uses subtle neutral dark-theme token with pulse animation respecting reduced-motion.
 */
export const Skeleton: React.FC<SkeletonProps> = ({ className = "", ...props }) => {
  const prefersReducedMotion = useReducedMotion();

  return (
    <div
      aria-hidden="true"
      className={`bg-panel-subtle/80 rounded ${
        prefersReducedMotion ? "" : "animate-pulse"
      } ${className}`}
      {...props}
    />
  );
};
